import type { HTMLAttributes, ReactNode } from 'react';

export type PrioLevel = 'high' | 'med' | 'low' | 'urgent';

export interface PrioProps extends HTMLAttributes<HTMLSpanElement> {
  level: PrioLevel;
  children: ReactNode;
}

/**
 * Priority chip — mono uppercase with a 7×7 filled square prefix in the
 * priority color. Matches dashboard.html `.prio`.
 */
export function Prio({ level, children, className, ...rest }: PrioProps) {
  const cls = ['pn-prio', `pn-prio-${level}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
